import React from "react";

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
	variant?: "default" | "primary" | "danger" | "ghost";
	size?: "sm" | "md" | "lg";
};

const sizeClasses = {
	sm: "h-8 px-3 text-sm",
	md: "h-10 px-3.5",
	lg: "h-11 px-4 text-base",
};

const variantClasses = {
	default: "btn",
	primary: "btn btn-primary",
	danger: "btn btn-danger",
	ghost: "btn",
};

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
	({ className = "", variant = "default", size = "md", ...props }, ref) => {
		return (
			<button
				ref={ref}
				className={`${variantClasses[variant]} ${sizeClasses[size]} ${className}`}
				{...props}
			/>
		);
	}
);
Button.displayName = "Button";
